import { addEarlyResizeListener, addLateResizeListener, addResizeListener, removeResizeListener } from './display';
import { Game } from './game';

export class MonoBehavior {
    _isActive = true;
    _isStarted = false;
    _startTime: number;
    _id: string;
    _update = false;

    constructor() {
        this._id = counter.getId();
        Game.addGameObject(this);
        this._startTime = performance.now();
        this.start = this.start.bind(this);

        this.earlyResize = this.earlyResize.bind(this);
        this.resize = this.resize.bind(this);
        this.lateResize = this.lateResize.bind(this);

        this.update = this.update.bind(this);
        this._setActive = this._setActive.bind(this);
        this.startGameObject = this.startGameObject.bind(this);
        this.destroy = this.destroy.bind(this);
        addEarlyResizeListener(this.earlyResize, this._id + '_early');
        addResizeListener(this.resize, this._id);
        addLateResizeListener(this.lateResize, this._id + '_late');
        this._update = Object.getPrototypeOf(this).update !== MonoBehavior.prototype.update;
    }

    beforeStart(): void {}
    start(): void {}
    update(): void {}
    beforeDestroy(): void {}
    _setActive(active: boolean) {
        this._isActive = active;
    }
    startGameObject() {
        this._isStarted = true;
        this.start();
    }
    beforeStartGameObject() {
        this.beforeStart();
    }
    destroy() {
        this._setActive(false);
        removeResizeListener(this._id);
        removeResizeListener(this._id + '_early');
        removeResizeListener(this._id + '_late');
        Game.removeGameObject(this._id);
    }
    getLifeTime() {
        return performance.now() - this._startTime;
    }
    resize(width: number, height: number): void {
        removeResizeListener(this._id);
    }
    earlyResize(width: number, height: number): void {
        removeResizeListener(this._id + '_early');
    }
    lateResize(width: number, height: number): void {
        removeResizeListener(this._id + '_late');
    }
}
class Counter {
    count = 0;
    getId() {
        this.count++;
        return `Monobehavior_${this.count}`;
    }
}
const counter = new Counter();
